import keymirror from 'keymirror';

export default keymirror({
  SEND_SUGGESTION: null,
  SEND_SUGGESTION_SUCCESS: null,
  SEND_SUGGESTION_ERROR: null,
  CLEAR_SUCCESS_MESSAGE: null,
});